// extracted by mini-css-extract-plugin
module.exports = {"space":"SelectedAudience_space__3ab8R","select":"SelectedAudience_select__24SPq"};